module.exports = __webpack_public_path__ + "static/img/character-boy-2.dc343fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/characters/character-boy-2.png
// module id = JkXn
// module chunks = 0